<template>
  <div class="container">
    <Loading v-if="Loading" />
    <Modal
      v-if="showModal"
      :modalMessage="modalMessage"
      @close-modal="goToDashboard"
    />
    <div class="content">
      <div class="header" v-if="!Loading">
        <h2>You Have Accepted The Order!</h2>
        <h3>You Now have 40 Minutes To Deliver The Order To The Customer!</h3>
        <p>
          Location To Be Delivered To:
        </p>
        <b>{{ orderDetails.userLocation }}</b>
        <p>
          Restaurant:
        </p>
        <b>{{ orderDetails.restaurantName }}</b>
        <p>
          Location Of The Restaurant:
        </p>
        <b>{{ orderDetails.restaurantLocation }}</b>
      </div>
      <div class="order-details" v-if="!Loading">
        <h2>Order Details</h2>
        <OrderSummaryItemView
          v-for="(food, index) in orderDetails.foodItems"
          :key="food"
          :itemName="food"
          :itemQuantity="orderDetails.foodItemsQuantity[index]"
        />
        <h6>Additional Requests:</h6>
        <p>{{ orderDetails.additionalRequests }}</p>
        <!--
        <table border="1px">
          <thead>
            <tr>
              <th class="tg-0lax">No.</th>
              <th>Food</th>
              <th>Quantity</th>
              <th class="tg-0lax">Remark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(food, index) in orderDetails.foodItems" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ food }}</td>
              <td>{{ orderDetails.foodItemsQuantity[index] }}</td>
              <td>{{ orderDetails.foodItemsRemarks[index] }}</td>
            </tr>
          </tbody>
        </table>
        -->
      </div>
      <div class="timer-and-button" v-if="!Loading">
        <Timer :deadline="deadline" />
        <button
          class="order-placed-at-restaurant-button"
          @click="orderPlacedAtRestaurant"
          v-if="orderPlacedButton"
        >
          Order Placed At The Restaurant/Stall
        </button>
        <button
          class="order-picked-up-button"
          @click="OrderPickedUpFromRestaurant"
          v-if="orderPickedButton"
        >
          Order Picked Up
        </button>
        <button
          class="en-route-to-save-savour-button"
          @click="enRouteToSaveSavour"
          v-if="enRouteToSaveButton"
        >
          En Route To Save Savour!
        </button>
        <button
          class="delivered-button"
          @click="deliveredTheOrder"
          v-if="deliveredButton"
        >
          I have Delivered the Order!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading.vue";
import Timer from "../components/Timer.vue";
import db from "../firebase/firebaseInit";
import OrderSummaryItemView from "../components/OrderSummaryItemView";
import firebase from "firebase/app";
import Modal from "../components/Modal";

export default {
  name: "Confirmed",
  methods: {
    goToDashboard() {
      this.showModal = false;
      this.$router.push({ name: "Dashboard" });
    },
    async orderPlacedAtRestaurant() {
      this.orderPlacedButton = false;
      this.orderPickedButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          orderPlacedAtRestaurant: true,
        });
    },
    async OrderPickedUpFromRestaurant() {
      this.orderPickedButton = false;
      this.enRouteToSaveButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          orderPickedFromRestaurant: true,
        });
    },
    async enRouteToSaveSavour() {
      this.enRouteToSaveButton = false;
      this.deliveredButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          enRouteToSave: true,
        });
    },
    async deliveredTheOrder() {
      await db
        .collection("users")
        .doc(this.$store.state.profileId)
        .update({
          delivering: false,
          deliveringId: "",
          ordersDelivered: firebase.firestore.FieldValue.arrayUnion(
            this.orderId
          ),
        });
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          delivered: true,
        });
      this.$router.push({
        name: "DeliveredTheOrder",
      });
    },
  },

  data() {
    return {
      orderDetails: null,
      deadline: null,
      Loading: true,
      orderPlacedButton: true,
      orderPickedButton: false,
      enRouteToSaveButton: false,
      deliveredButton: false,
      showModal: false,
      modalMessage: "The Order Does Not Exist!",
    };
  },
  props: ["orderId"],
  components: {
    Timer,
    Loading,
    OrderSummaryItemView,
    Modal,
  },
  created() {
    var docRef = db.collection("orders").doc(this.orderId);
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data OK:", doc.data());
          this.orderDetails = doc.data();
          this.deadline = this.orderDetails.deliveryTime.toDate();
          this.Loading = false;
          console.log("after fetching orderDetails ->", this.orderDetails);

          if (!this.orderDetails.orderPlacedAtRestaurant) {
            this.orderPlacedButton = true;
          } else {
            this.orderPlacedButton = false;
          }

          if (this.orderDetails.orderPlacedAtRestaurant) {
            this.orderPlacedButton = false;
            this.orderPickedButton = true;
          }
          if (this.orderDetails.orderPickedFromRestaurant) {
            this.orderPickedButton = false;
            this.enRouteToSaveButton = true;
          }
          if (this.orderDetails.enRouteToSave) {
            this.enRouteToSaveButton = false;
            this.deliveredButton = true;
          }
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
          //this.Loading = false;
          this.showModal = true;
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container {
  //margin: 0;
  display: flex;
  justify-content: center;

  button {
    margin: 10px auto;
    min-width: 180px;

    &:hover {
      cursor: pointer;
      background-color: rgb(50, 50, 50);
      transition: 0.25s;
    }
  }

  .content {
    margin: 10px auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    gap: 16px;

    @media (min-width: 800px) {
      flex-direction: row;
    }

    .header {
      flex-basis: 34%;

      padding: 20px;
      background-color: #f1f1f1;
      border-radius: 8px;

      h3 {
        margin-bottom: 20px;
      }

      p,
      b {
        font-size: 20px;
      }

      p {
        margin-top: 10px;
      }
    }

    .order-details {
      flex-basis: 33%;
      padding: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 8px;

      h2 {
        color: #fff;
        text-align: center;
      }

      p {
        text-align: left;
        color: #fff;
        font-size: 16px;
      }

      h6 {
        margin-top: 5px;
        margin-bottom: 0;
        color: #fff;
        font-size: 20px;
        text-align: left;
      }
    }

    .timer-and-button {
      flex-basis: 33%;
      display: flex;
      flex-direction: column;

      .delivered-button {
        margin: 10px auto;
        min-width: 180px;

        &:hover {
          cursor: pointer;
          background-color: rgb(50, 50, 50);
          transition: 0.25s;
        }
      }
    }
  }
}
</style>
